import config from "../../config.json";
import { MenuApiError, menuRequest } from "./menu";

// AI Menu Import (backend: /api/auth/ai/menu-imports). Drafts never change
// live menus; only approve() does, through the regular menu services.

const BASE = "ai/menu-imports";

export const fetchAiImportConfigAPI = async () => (await menuRequest(`${BASE}/config`)).config;
export const fetchAiImportsAPI = async (restaurant, { includeArchived = false } = {}) =>
  (await menuRequest(`${BASE}?restaurant=${encodeURIComponent(restaurant)}${includeArchived ? "&includeArchived=true" : ""}`)).imports || [];
export const fetchAiImportAPI = async (importId) => (await menuRequest(`${BASE}/${importId}`)).import;

// { file, restaurant, mode, menuId?, menuName? } -> { import, duplicate }
export const uploadAiImportAPI = ({ file, restaurant, mode, menuId, menuName }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("restaurant", restaurant);
  form.append("mode", mode);
  if (menuId) form.append("menuId", menuId);
  if (menuName) form.append("menuName", menuName);
  return menuRequest(BASE, { method: "POST", form });
};

// { revision, operations?, intent? } -> updated draft
export const updateAiImportAPI = async (importId, data) => (await menuRequest(`${BASE}/${importId}`, { method: "PATCH", body: data })).import;
export const fetchAiImportPlanAPI = (importId) => menuRequest(`${BASE}/${importId}/plan`);
export const approveAiImportAPI = (importId, revision) => menuRequest(`${BASE}/${importId}/approve`, { method: "POST", body: { revision } });
export const archiveAiImportAPI = async (importId, reason = "") => (await menuRequest(`${BASE}/${importId}/archive`, { method: "POST", body: { reason } })).import;
export const retryAiImportAPI = async (importId) => (await menuRequest(`${BASE}/${importId}/retry`, { method: "POST" })).import;

// The original upload as a Blob (served with auth, never a public URL).
export async function fetchAiImportSourceAPI(importId) {
  const token = localStorage.getItem("auth-token");
  const response = await fetch(`${config.BASE_AUTH_API}${BASE}/${importId}/source`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new MenuApiError(data.message || "Request failed", { status: response.status, code: data.code });
  }
  return response.blob();
}
// Approve All: what it would approve / keep excluded / still needs (read only),
// then confirm every remaining entry and approve in ONE request (idempotent).
export const fetchAiImportApproveAllAPI = (importId) => menuRequest(`${BASE}/${importId}/approve-all`);
export const approveAllAiImportAPI = (importId, revision) => menuRequest(`${BASE}/${importId}/approve-all`, { method: "POST", body: { revision } });
